import { useState, useEffect } from "react";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerLeagues = (idplayer) => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!idplayer) return;

    const fetchLeagues = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api.php?endpoint=player_leagues&idplayer=${idplayer}`);
        setLeagues(response.data);
      } catch (error) {
        console.error("Error fetching player leagues:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeagues();
  }, [idplayer]);

  console.log("Leagues: ", leagues);

  return { leagues, loading };
};